
import { defineComponent, PropType, computed, ref } from "vue";
import store, { EditStore } from "@/stores";
import {
  IImageMaterial,
  MaterialRights,
  MaterialTypes,
} from "@/services/Models";
import Thumbnail from "@/components/Thumbnail.vue";
import { toResourceUrl, dragDataKeyImageObject } from "@/lib/shared";

export default defineComponent({
  name: "EditCommandOnomatope",
  components: {
    Thumbnail,
  },
  props: {
    editStore: { type: Object as PropType<EditStore> },
  },
  setup() {
    const resource = store.useResource();
    // 効果音
    const publicMaterials = computed(() =>
      resource.data.imageMaterials.filter(
        (x) => x.right == MaterialRights.Public && x.type == MaterialTypes.Image
      )
    );
    const selectedItem = ref<IImageMaterial>();
    const toItem = (image: IImageMaterial) => ({
      imgPath: toResourceUrl(image.path),
      clickAction: () => {
        selectedItem.value = image;
      },
    });

    // データをJSON形式に変換し、ドラッグで指定した位置にコピーする
    const dragstart = (e: DragEvent, item: IImageMaterial) => {
      if (!e.dataTransfer) return;
      const data = JSON.stringify(item);
      e.dataTransfer.setData(dragDataKeyImageObject, data);
      e.dataTransfer.effectAllowed = "copy";
    };
    return {
      publicMaterials,
      toItem,
      selectedItem,
      dragstart,
    };
  },
});
